export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senha"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digite a senha de confirmação"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senha de confirmação"])}
}